import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import 'swiper/css';
import 'swiper/css/zoom';
import 'swiper/css/autoplay';
import { Zoom, Navigation, Pagination } from 'swiper/modules';

const ProductImageSlider = ({ images }: { images: string[] }) => {
 // const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  return (
    <div className="product-slider">
      {/* Main Image Slider */}
      <Swiper
        loop={true}
        spaceBetween={10}
        navigation={true}
        zoom={true}
        pagination={{
            clickable: true,
          }}
        modules={[Zoom, Navigation, Pagination]}
  
        className="main-slider"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="swiper-zoom-container">
                <img src={process.env.REACT_APP_SERVER_URL + img} alt={`Product ${index}`} className="main-image" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnail Slider */}
      {/* <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        
          zoom={true}
          navigation={true}
          pagination={{
            clickable: true,
          }}
        modules={[Zoom, Navigation, Pagination]}
        className="thumbnail-slider"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <img src={process.env.REACT_APP_SERVER_URL +  img} alt={`Thumbnail ${index}`} className="thumb-image" />
          </SwiperSlide>
        ))}
      </Swiper> */}
    </div>
  );
};
export default ProductImageSlider;
